export const getRiskAmountPerTrade = (accountRiskPercent: number, accountSize: number): number => {
  return Math.trunc((accountRiskPercent * accountSize) / 100);
};
